import { useEffect, useState } from "react";

type Readiness = {
  trade_permission: string;
  research_ui: string;
  closed_bar_rebuild: string;
  external_pine_runtime_parity: string;
  economic_model: string;
  paper_observation: string;
  bybit_public_testnet_read: string;
  bybit_private_or_execution: string;
  live_release: string;
  notice: string;
};

type Economics = {
  status: string;
  required_inputs: string[];
  excluded_now: string[];
  decision_gate: string;
};

type Testnet = {
  base_url: string;
  allowed: string[];
  blocked: string[];
  trade_permission: string;
  private_boundary: { execution: string; private_read: string };
};

export default function ResearchReadiness({ token, onClose }: { token: string; onClose: () => void }) {
  const [readiness, setReadiness] = useState<Readiness | null>(null);
  const [economics, setEconomics] = useState<Economics | null>(null);
  const [testnet, setTestnet] = useState<Testnet | null>(null);
  const [serverTime, setServerTime] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const headers = { Authorization: "Bearer " + token };
    Promise.all([
      fetch("/api/research-readiness/summary", { headers }),
      fetch("/api/research-readiness/economics-plan", { headers }),
      fetch("/api/research-readiness/bybit-testnet", { headers }),
    ])
      .then(async ([summary, plan, testnetResponse]) => {
        if (!summary.ok || !plan.ok || !testnetResponse.ok) throw new Error("Не удалось загрузить статус готовности");
        setReadiness((await summary.json()) as Readiness);
        setEconomics((await plan.json()) as Economics);
        setTestnet((await testnetResponse.json()) as Testnet);
      })
      .catch((reason: unknown) => setError(reason instanceof Error ? reason.message : "Ошибка"));
  }, [token]);

  const loadTime = async () => {
    setError("");
    const response = await fetch("/api/research-readiness/bybit-testnet/time", { headers: { Authorization: "Bearer " + token } });
    if (!response.ok) { setError("Не удалось получить публичное время Bybit Testnet"); return; }
    const payload = await response.json() as { payload?: { result?: { timeSecond?: string } } };
    setServerTime(payload.payload?.result?.timeSecond ?? "получено");
  };

  return <section className="knowledge-overlay"><div className="rules-page">
    <header><div><small>Read-only · выпуск заблокирован</small><h1>Готовность исследовательского контура</h1></div><button onClick={onClose}>Закрыть</button></header>
    {error && <p className="knowledge-error">{error}</p>}
    {readiness && <div className="rule-list">
      <article className="rule-card rule-unknown"><header><div><h2>Текущее решение</h2><small>Закрыто-барная реконструкция: {readiness.closed_bar_rebuild}</small></div><span className="research-denied">{readiness.trade_permission}</span></header><p>{readiness.notice}</p><footer><span>Pine: {readiness.external_pine_runtime_parity}</span><span>Реальный выпуск: {readiness.live_release}</span></footer></article>
      <article className="rule-card rule-unknown"><header><div><h2>Экономическое измерение</h2><small>Статус: {economics?.status ?? "загрузка"}</small></div><span className="research-denied">не рассчитано</span></header><p>{economics?.decision_gate}</p><footer><span>Нужны: {economics?.required_inputs.join(", ")}</span><span>Исключено: {economics?.excluded_now.join(", ")}</span></footer></article>
      <article className="rule-card rule-unknown"><header><div><h2>Bybit Testnet</h2><small>{testnet?.base_url}</small></div><span className="research-denied">{testnet?.trade_permission}</span></header><p>Разрешены только публичные данные тестовой среды.</p><footer><span>{testnet?.allowed.join(", ")}</span><span>Private: {testnet?.private_boundary.private_read}; исполнение: {testnet?.private_boundary.execution}</span><button onClick={loadTime}>Проверить публичное время</button><span>{serverTime && "Время сервера: " + serverTime}</span></footer></article>
    </div>}
  </div></section>;
}
